import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { take } from 'rxjs';
import { OauthService } from 'src/app/oauth.service';
import { SsoStrategyService } from 'src/app/sso-strategy.service';
import { Location } from '@angular/common';
import { UrlSettingsCore } from '../../configuration/url-settings-core';

@Component({
  selector: 'app-forbidden',
  templateUrl: './forbidden.component.html',
  styleUrls: ['./forbidden.component.css']
})
export class ForbiddenComponent implements OnInit {
  constructor(
    private oauth: OauthService,
    private ssoStrategy: SsoStrategyService,
    private router: Router,
    private location: Location
  ) {}

  ngOnInit(): void {}
  
  logoutAndLogin() {
    this.oauth.invalidateTokenSession();
  }

  // Fix #8: rimosso onAccessTokenObtained(true) che causava la reinizializzazione
  // completa dell'utente (getUser, getRolesByUserData, loadConfigurations, refreshTokenTimer)
  // quando si stava solo aggiornando un token già esistente.
  // Ora salva i token, rimuove lo stato forbidden e naviga senza effetti collaterali.
  onAggiornaSessione() {
    this.oauth.refreshAccessToken().pipe(take(1)).subscribe({
      next: (res) => {
        localStorage.setItem("access_token", res.access_token);
        localStorage.setItem("refresh_token", res.refresh_token);
        localStorage.setItem("expires_in", res.expires_in.toString());
        localStorage.setItem("refresh_expires_in", res.refresh_expires_in.toString());
        localStorage.setItem("session_state", res.session_state);
        localStorage.setItem("id_token", res.id_token);
        this.ssoStrategy.onForbidden(false);
        const canGoBack = window.history.length > 1;
        if (canGoBack) {
          this.location.back();
        } else {
          this.router.navigate([UrlSettingsCore.URL_VISUALIZZA_WELCOME_BOARD]);
        }
      },
      error: (err) => {
        this.oauth.invalidateTokenSession();
      }
    });
  }
}